import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class DownloadFile extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          info:"Verifing permissions....",
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          code:"",
          link:"",
          isLoading:false
      };
    }

    async componentWillMount() {
      if(this.props.match.params.id.length>0 && this.props.match.params.file.length>0){
        let res=await this.getAccess(this.props.match.params.id,this.props.match.params.file)
        if(res.link.length!=0){
          //alert(res.link)
          this.setState(res)
          const link = document.createElement('a');
          link.href = res.link;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }




getAccess(id,file){
  let data = {
    'queryStringParameters': {
        'file': file,
        'id':id,
    }
  }
  return API.get("AltiomData", "/welcome",data);
}

    render() {
      return (
          <div className="Home">
            <Jumbotron>
            <h2>{this.state.info}</h2>
            <i>Altiom:{this.props.match.params.id}</i><br/>
            <i>file:{this.props.match.params.file}</i><br/>
            { this.state.link.length >0 ?(<a href={this.state.link} download>Download</a>):("")}
            <br/>
            <br/>
            <br/>
            <br/>
            <a href={"/a/"+this.props.match.params.id}>View Altiom</a>


            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/DownloadFile.js